import React from "react";

export const keyToComponent = {
  chevrondroite: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42 42">
      <path
        d="M17.09,29.63a.49.49,0,0,1-.35-.15.5.5,0,0,1,0-.71l7.61-7.61-7.61-7.61a.5.5,0,0,1,0-.71.48.48,0,0,1,.7,0l8.32,8.32-8.32,8.32A.47.47,0,0,1,17.09,29.63Z"
        transform="translate(-0.18 -0.16)"
      ></path>
      <path
        d="M42.18,42.16H.18V.16h42Zm-41-1h40v-40h-40Z"
        transform="translate(-0.18 -0.16)"
      ></path>
    </svg>
  ),
  blueline: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 417 5">
      <path
        className="cls-1"
        d="M414.5,0a2.5,2.5,0,0,0-2.45,2H5A2.5,2.5,0,1,0,5,3h407.1a2.5,2.5,0,1,0,2.45-3Z"
      ></path>
    </svg>
  ),
  reviewstar: (
    <svg className="star--svg" version="1.1">
      <g viewBox="0 0 102 18">
        <path d="M9.5 14.25l-5.584 2.936 1.066-6.218L.465 6.564l6.243-.907L9.5 0l2.792 5.657 6.243.907-4.517 4.404 1.066 6.218"></path>
      </g>
    </svg>
  ),
  trashcart: (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6 0C5.62123 0 5.27497 0.214002 5.10557 0.552786L4.38197 2H1C0.447715 2 0 2.44772 0 3C0 3.55228 0.447716 4 1 4L1 14C1 15.1046 1.89543 16 3 16H11C12.1046 16 13 15.1046 13 14V4C13.5523 4 14 3.55228 14 3C14 2.44772 13.5523 2 13 2H9.61804L8.89443 0.552786C8.72504 0.214002 8.37877 0 8 0H6ZM4 6C4 5.44772 4.44772 5 5 5C5.55228 5 6 5.44772 6 6V12C6 12.5523 5.55228 13 5 13C4.44772 13 4 12.5523 4 12V6ZM9 5C8.44771 5 8 5.44772 8 6V12C8 12.5523 8.44771 13 9 13C9.55229 13 10 12.5523 10 12V6C10 5.44772 9.55229 5 9 5Z"
        fill="currentColor"
      />
    </svg>
  ),
  whiteline: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 417 5">
      <path
        className="cls-1"
        d="M414.5,0a2.5,2.5,0,0,0-2.45,2H5A2.5,2.5,0,1,0,5,3h407.1a2.5,2.5,0,1,0,2.45-3Z"
      ></path>
    </svg>
  ),
  facebook: (
    <svg
      className="SVGInline-svg"
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="18"
      viewBox="0 0 10 18"
    >
      <g>
        <g>
          <path
            fill="#002C52"
            d="M9.016.004L6.769 0C4.245 0 2.613 1.674 2.613 4.264V6.23H.354a.353.353 0 0 0-.353.354v2.848c0 .195.158.353.353.353h2.26v7.188c0 .195.157.353.353.353h2.947a.353.353 0 0 0 .353-.353V9.785H8.91a.353.353 0 0 0 .353-.353l.001-2.848a.354.354 0 0 0-.353-.354H6.267V4.563c0-.8.191-1.207 1.235-1.207h1.513a.353.353 0 0 0 .354-.354V.357a.353.353 0 0 0-.353-.353z"
          ></path>
        </g>
      </g>
    </svg>
  ),
  linkedin: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 24 24"
    >
      <path d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z" />
    </svg>
  ),
  instagram: (
    <svg
      className="SVGInline-svg"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
    >
      <g>
        <g>
          <g>
            <path
              fill="#002C52"
              d="M16.118 12.287a3.453 3.453 0 0 1-3.452 3.452H5.592a3.453 3.453 0 0 1-3.453-3.452V5.213a3.453 3.453 0 0 1 3.453-3.452h7.074a3.453 3.453 0 0 1 3.452 3.452zM12.666 0H5.592A5.22 5.22 0 0 0 .38 5.213v7.074A5.22 5.22 0 0 0 5.592 17.5h7.074a5.22 5.22 0 0 0 5.213-5.213V5.213A5.22 5.22 0 0 0 12.666 0z"
            ></path>
          </g>
          <g>
            <path
              fill="#002C52"
              d="M9.129 11.516a2.766 2.766 0 1 1 0-5.532 2.766 2.766 0 0 1 0 5.532zm0-7.292A4.531 4.531 0 0 0 4.603 8.75a4.531 4.531 0 0 0 4.526 4.526 4.531 4.531 0 0 0 4.526-4.526A4.531 4.531 0 0 0 9.13 4.224z"
            ></path>
          </g>
          <g>
            <path
              fill="#002C52"
              d="M12.58 4.258a1.085 1.085 0 1 1 2.168 0 1.085 1.085 0 0 1-2.169 0z"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  ),
  viadeo: (
    <svg
      className="SVGInline-svg"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
    >
      <path
        fill="#002C52"
        d="M15.4,1.1c-2.5-0.1-4.2,1.3-5.1,4.3c0.5-0.2,0.9-0.3,1.3-0.3c0.9,0,1.3,0.5,1.2,1.6c-0.1,0.6-0.5,1.5-1.2,2.7 c-0.8,1.2-1.3,1.8-1.7,1.8c-1.1,0-1.8-5.5-2.1-6.9c-0.3-2.1-1.2-3-2.6-2.9C4,1.5,1.8,3.8,0,5.4l0.8,1.1c0.8-0.6,1.3-0.9,1.4-0.9 c1.4,0,2.1,4.8,3.2,8.3c0.7,2,1.6,2.9,2.7,2.9c1.7,0,3.8-1.6,6.2-4.8C16.7,9,17.9,6.5,18,4.8l0,0C18.1,2.4,17.2,1.2,15.4,1.1 L15.4,1.1z"
      />
    </svg>
  ),
  cb: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15.012"
      height="19.516"
      viewBox="0 0 15.012 19.516"
    >
      <path
        d="M19.885,10.13H18.759V7.939a4.5,4.5,0,1,0-9.007-.061V10.13H8.626A1.882,1.882,0,0,0,6.75,12.007v9.007A1.882,1.882,0,0,0,8.626,22.89H19.885a1.882,1.882,0,0,0,1.876-1.876V12.007A1.882,1.882,0,0,0,19.885,10.13Zm-4.973,5.855v3.228a.673.673,0,0,1-.624.676.658.658,0,0,1-.69-.657V15.985a1.5,1.5,0,1,1,1.314,0Zm2.533-5.855h-6.38V7.878a3.19,3.19,0,0,1,6.38,0Z"
        transform="translate(-6.75 -3.374)"
        fill="currentColor"
      ></path>
    </svg>
  ),
  trash: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25.064"
      height="30.849"
      viewBox="0 0 25.064 30.849"
    >
      <path
        d="M6.427,11.568v19.28a1.934,1.934,0,0,0,1.928,1.928H25.707a1.934,1.934,0,0,0,1.928-1.928V11.568H6.427Zm5.784,17.352H10.283v-13.5h1.928Zm3.856,0H14.139v-13.5h1.928Zm3.856,0H17.995v-13.5h1.928Zm3.856,0H21.851v-13.5h1.928ZM28.117,5.784H21.851V3.374a1.45,1.45,0,0,0-1.446-1.446H13.657a1.45,1.45,0,0,0-1.446,1.446v2.41H5.945A1.45,1.45,0,0,0,4.5,7.23V9.64H29.563V7.23a1.45,1.45,0,0,0-1.446-1.446Zm-8.194,0H14.139V3.88h5.784v1.9Z"
        transform="translate(-4.499 -1.928)"
      ></path>
    </svg>
  ),
  user: (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 12 12"
      className="icon icon--default icon--default-block"
      height="1em"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7.7,6.5C8.5,5.9,9.1,5,9.1,3.9c0-1.7-1.4-3.1-3.1-3.1S2.9,2.2,2.9,3.9c0,1.1,0.5,2,1.4,2.6C2.5,7.1,1.2,8.8,1,10.7 c0,0.2,0.2,0.5,0.4,0.5c0.2,0,0.4-0.2,0.4-0.4C2.1,8.7,3.9,7,6,7s3.9,1.6,4.1,3.7c0,0.2,0.2,0.4,0.4,0.4c0.2,0,0.4-0.2,0.4-0.5 C10.8,8.8,9.5,7.1,7.7,6.5z M3.8,3.9c0-1.2,1-2.2,2.2-2.2s2.2,1,2.2,2.2S7.2,6.2,6,6.2S3.8,5.2,3.8,3.9z" />
    </svg>
  ),
  cart: (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 12 12"
      className="icon icon--default"
      height="1em"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M9.4,4.3c0-0.2-0.2-0.3-0.4-0.3H8.3V2.7C8.3,2.4,8.2,2,8,1.7C7.7,1,7,0.6,6.1,0.6C5.3,0.6,4.6,1,4.2,1.7C4,2,4,2.4,4,2.7 v1.2H3.3c-0.2,0-0.4,0.1-0.4,0.3L2,11c0,0.1,0,0.2,0.1,0.3c0.1,0.1,0.2,0.1,0.3,0.1h7.6c0.1,0,0.2,0,0.3-0.1s0.1-0.2,0.1-0.3 L9.4,4.3z M4.7,2.7c0-0.3,0.1-0.5,0.2-0.7c0.2-0.5,0.7-0.7,1.2-0.7s1,0.2,1.2,0.7c0.1,0.2,0.2,0.5,0.2,0.7v1.2H4.7V2.7z M2.8,10.7 l0.8-6H4v0.5h0C3.8,5.3,3.8,5.4,3.8,5.6c0,0.3,0.3,0.6,0.6,0.6s0.6-0.3,0.6-0.6c0-0.2-0.1-0.3-0.2-0.4h0V4.7h2.8v0.5h0 C7.4,5.3,7.3,5.4,7.3,5.6c0,0.3,0.3,0.6,0.6,0.6s0.6-0.3,0.6-0.6c0-0.2-0.1-0.3-0.2-0.4h0V4.7h0.4l0.8,6H2.8z" />
    </svg>
  ),
  account_circle: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
    >
      <path d="M234-276q51-39 114-61.5T480-360q69 0 132 22.5T726-276q35-41 54.5-93T800-480q0-133-93.5-226.5T480-800q-133 0-226.5 93.5T160-480q0 59 19.5 111t54.5 93Zm246-164q-59 0-99.5-40.5T340-580q0-59 40.5-99.5T480-720q59 0 99.5 40.5T620-580q0 59-40.5 99.5T480-440Zm0 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q53 0 100-15.5t86-44.5q-39-29-86-44.5T480-280q-53 0-100 15.5T294-220q39 29 86 44.5T480-160Zm0-360q26 0 43-17t17-43q0-26-17-43t-43-17q-26 0-43 17t-17 43q0 26 17 43t43 17Zm0-60Zm0 360Z" />
    </svg>
  ),
  add: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
    >
      <path d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z" />
    </svg>
  ),
  checkmark: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
    >
      <path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z" />
    </svg>
  ),
  chevron_left: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
    >
      <path d="M560-240 320-480l240-240 56 56-184 184 184 184-56 56Z" />
    </svg>
  ),
  chevron_right: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
    >
      <path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z" />
    </svg>
  ),
  close: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
    >
      <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
    </svg>
  ),
  edit: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
    >
      <path d="M200-200h57l391-391-57-57-391 391v57Zm-80 80v-170l528-527q12-11 26.5-17t30.5-6q16 0 31 6t26 18l55 56q12 11 17.5 26t5.5 30q0 16-5.5 30.5T817-647L290-120H120Zm640-584-56-56 56 56Zm-141 85-28-29 57 57-29-28Z" />
    </svg>
  ),
  favorite: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
    >
      <path d="m480-120-58-52q-101-91-167-157T150-447.5Q111-500 95.5-544T80-634q0-94 63-157t157-63q52 0 99 22t81 62q34-40 81-62t99-22q94 0 157 63t63 157q0 46-15.5 90T810-447.5Q771-395 705-329T538-172l-58 52Zm0-108q96-86 158-147.5t98-107q36-45.5 50-81t14-70.5q0-60-40-100t-100-40q-47 0-87 26.5T518-680h-76q-15-41-55-67.5T300-774q-60 0-100 40t-40 100q0 35 14 70.5t50 81q36 45.5 98 107T480-228Zm0-273Z" />
    </svg>
  ),
  globe: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
    >
      <path d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-7-.5-14.5T799-507q-5 29-27 48t-52 19h-80q-33 0-56.5-23.5T560-520v-40H400v-80q0-33 23.5-56.5T480-720h40q0-23 12.5-40.5T563-789q-20-5-40.5-8t-42.5-3q-134 0-227 93t-93 227h200q66 0 113 47t47 113v40H400v110q20 5 39.5 7.5T480-160Z" />
    </svg>
  ),
  info: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
    >
      <path d="M440-280h80v-240h-80v240Zm40-320q17 0 28.5-11.5T520-640q0-17-11.5-28.5T480-680q-17 0-28.5 11.5T440-640q0 17 11.5 28.5T480-600Zm0 520q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
    </svg>
  ),
  keyboard_arrow_down: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
    >
      <path d="M480-344 240-584l56-56 184 184 184-184 56 56-240 240Z" />
    </svg>
  ),
  keyboard_arrow_up: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
    >
      <path d="M480-528 296-344l-56-56 240-240 240 240-56 56-184-184Z" />
    </svg>
  ),
  open_in_new: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
    >
      <path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h280v80H200v560h560v-280h80v280q0 33-23.5 56.5T760-120H200Zm188-212-56-56 372-372H560v-80h280v280h-80v-144L388-332Z" />
    </svg>
  ),
  picture_as_pdf: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
    >
      <path d="M360-460h40v-80h40q17 0 28.5-11.5T480-580v-40q0-17-11.5-28.5T440-660h-80v200Zm40-120v-40h40v40h-40Zm120 120h80q17 0 28.5-11.5T640-500v-120q0-17-11.5-28.5T600-660h-80v200Zm40-40v-120h40v120h-40Zm120 40h40v-80h40v-40h-40v-40h40v-40h-80v200ZM320-240q-33 0-56.5-23.5T240-320v-480q0-33 23.5-56.5T320-880h480q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H320Zm0-80h480v-480H320v480ZM160-80q-33 0-56.5-23.5T80-160v-560h80v560h560v80H160Zm160-720v480-480Z" />
    </svg>
  ),
  remove: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
    >
      <path d="M200-440v-80h560v80H200Z" />
    </svg>
  ),
  search: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
    >
      <path d="M784-120 532-372q-30 24-69 38t-83 14q-109 0-184.5-75.5T120-580q0-109 75.5-184.5T380-840q109 0 184.5 75.5T640-580q0 44-14 83t-38 69l252 252-56 56ZM380-400q75 0 127.5-52.5T560-580q0-75-52.5-127.5T380-760q-75 0-127.5 52.5T200-580q0 75 52.5 127.5T380-400Z" />
    </svg>
  ),
  tune: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
    >
      <path d="M440-120v-240h80v80h320v80H520v80h-80Zm-320-80v-80h240v80H120Zm160-160v-80H120v-80h160v-80h80v240h-80Zm160-80v-80h400v80H440Zm160-160v-240h80v80h160v80H680v80h-80Zm-480-80v-80h400v80H120Z" />
    </svg>
  ),
  shopping_cart: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
    >
      <path d="M280-80q-33 0-56.5-23.5T200-160q0-33 23.5-56.5T280-240q33 0 56.5 23.5T360-160q0 33-23.5 56.5T280-80Zm400 0q-33 0-56.5-23.5T600-160q0-33 23.5-56.5T680-240q33 0 56.5 23.5T760-160q0 33-23.5 56.5T680-80ZM246-720l96 200h280l110-200H246Zm-38-80h590q23 0 35 20.5t1 41.5L692-482q-11 20-29.5 31T622-440H324l-44 80h480v80H280q-45 0-68-39.5t-2-78.5l54-98-144-304H40v-80h130l38 80Zm134 280h280-280Z" />
    </svg>
  ),
  person: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
    >
      <path d="M480-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM160-160v-112q0-34 17.5-62.5T224-378q62-31 126-46.5T480-440q66 0 130 15.5T736-378q29 15 46.5 43.5T800-272v112H160Z" />
    </svg>
  ),
  payment_card: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
    >
      <path d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm0-80h640v-480H160v480Zm40-40h400L400-680H200v400Zm320-320h240v-80H520v80ZM160-240v-480 480Z" />
    </svg>
  ),
  shipping: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
    >
      <path d="M280-160q-50 0-85-35t-35-85H60l18-80h113q17-19 40-29.5t49-10.5q26 0 49 10.5t40 29.5h167l84-360H182l4-17q6-28 27.5-45.5T264-800h456l-37 160h117l120 160-40 200h-80q0 50-35 85t-85 35q-50 0-85-35t-35-85H400q0 50-35 85t-85 35Zm357-280h193l4-21-74-99h-95l-28 120Zm-19-273 2-7-84 360 2-7 34-146 46-200ZM20-427l20-80h220l-20 80H20Zm80-146 20-80h260l-20 80H100Zm180 333q17 0 28.5-11.5T320-280q0-17-11.5-28.5T280-320q-17 0-28.5 11.5T240-280q0 17 11.5 28.5T280-240Zm400 0q17 0 28.5-11.5T720-280q0-17-11.5-28.5T680-320q-17 0-28.5 11.5T640-280q0 17 11.5 28.5T680-240Z" />
    </svg>
  ),
  paypal: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 0 640 640"
      width="24px"
      fill="currentColor"
    >
      <path d="M218.3 322.2C218.3 334.4 208.6 343.7 196.3 343.7C187.1 343.7 180.3 338.5 180.3 328.7C180.3 316.5 189.8 306.7 202 306.7C211.3 306.7 218.3 312.4 218.3 322.2zM112.5 273.7L107.8 273.7C106.3 273.7 104.8 274.7 104.6 276.4L100.3 303.1L108.5 302.8C119.5 302.8 128 301.3 130 288.6C132.3 275.2 123.8 273.7 112.5 273.7zM396.5 273.7L392 273.7C390.2 273.7 389 274.7 388.8 276.4L384.6 303.1L392.6 302.8C405.6 302.8 414.6 299.8 414.6 284.8C414.5 274.2 405 273.7 396.5 273.7zM608 144L608 496C608 522.5 586.5 544 560 544L80 544C53.5 544 32 522.5 32 496L32 144C32 117.5 53.5 96 80 96L560 96C586.5 96 608 117.5 608 144zM160.3 279.4C160.3 258.4 144.1 251.4 125.6 251.4L85.6 251.4C83.1 251.4 80.6 253.4 80.4 256.1L64 358.2C63.7 360.2 65.2 362.2 67.2 362.2L86.2 362.2C88.9 362.2 91.4 359.3 91.7 356.5L96.2 329.9C97.2 322.7 109.4 325.2 114.2 325.2C142.8 325.2 160.3 308.2 160.3 279.4zM244.5 288.2L225.5 288.2C221.7 288.2 221.5 293.7 221.3 296.4C215.5 287.9 207.1 286.4 197.6 286.4C173.1 286.4 154.4 307.9 154.4 331.6C154.4 351.1 166.6 363.8 186.1 363.8C195.1 363.8 206.3 358.9 212.6 351.9C212.1 353.4 211.6 356.6 211.6 358.1C211.6 360.4 212.6 362.1 214.8 362.1L232 362.1C234.7 362.1 237 359.2 237.5 356.4L247.7 292.1C248 290.2 246.5 288.2 244.5 288.2zM285 386.1L348.7 293.5C349.2 293 349.2 292.5 349.2 291.8C349.2 290.1 347.7 288.3 346 288.3L326.8 288.3C325.1 288.3 323.3 289.3 322.3 290.8L295.8 329.8L284.8 292.3C284 290.1 281.8 288.3 279.3 288.3L260.6 288.3C258.9 288.3 257.4 290.1 257.4 291.8C257.4 293 276.9 348.6 278.6 353.9C275.9 357.7 258.1 382.5 258.1 385.5C258.1 387.3 259.6 388.7 261.3 388.7L280.5 388.7C282.3 388.6 284 387.6 285 386.1zM444.3 279.4C444.3 258.4 428.1 251.4 409.6 251.4L369.9 251.4C367.2 251.4 364.7 253.4 364.4 256.1L348.2 358.1C348 360.1 349.5 362.1 351.4 362.1L371.9 362.1C373.9 362.1 375.4 360.6 375.9 358.9L380.4 329.9C381.4 322.7 393.6 325.2 398.4 325.2C426.8 325.2 444.3 308.2 444.3 279.4zM528.5 288.2L509.5 288.2C505.7 288.2 505.5 293.7 505.2 296.4C499.7 287.9 491.2 286.4 481.5 286.4C457 286.4 438.3 307.9 438.3 331.6C438.3 351.1 450.5 363.8 470 363.8C479.3 363.8 490.5 358.9 496.5 351.9C496.2 353.4 495.5 356.6 495.5 358.1C495.5 360.4 496.5 362.1 498.7 362.1L516 362.1C518.7 362.1 521 359.2 521.5 356.4L531.7 292.1C532 290.2 530.5 288.2 528.5 288.2zM576 254.9C576 252.9 574.5 251.4 572.8 251.4L554.3 251.4C552.8 251.4 551.3 252.6 551.1 254.1L534.9 358.1L534.6 358.6C534.6 360.4 536.1 362.1 538.1 362.1L554.6 362.1C557.1 362.1 559.6 359.2 559.8 356.4L576 255.2L576 254.9zM486 306.7C473.8 306.7 464.3 316.4 464.3 328.7C464.3 338.4 471.3 343.7 480.5 343.7C492.5 343.7 502.2 334.5 502.2 322.2C502.3 312.4 495.3 306.7 486 306.7z" />
    </svg>
  ),
  monny_check: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 0 640 640"
      width="24px"
      fill="currentColor"
    >
      <path d="M64 192C64 156.7 92.7 128 128 128L512 128C547.3 128 576 156.7 576 192L576 448C576 483.3 547.3 512 512 512L128 512C92.7 512 64 483.3 64 448L64 192zM160 376C160 389.3 170.7 400 184 400L328 400C341.3 400 352 389.3 352 376C352 362.7 341.3 352 328 352L184 352C170.7 352 160 362.7 160 376zM184 240C170.7 240 160 250.7 160 264C160 277.3 170.7 288 184 288L456 288C469.3 288 480 277.3 480 264C480 250.7 469.3 240 456 240L184 240z" />
    </svg>
  ),
  apple_pay: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 0 640 640"
      width="24px"
      fill="currentColor"
    >
      <path d="M320 176C311.2 176 304 168.8 304 160L304 144C304 99.8 339.8 64 384 64L400 64C408.8 64 416 71.2 416 80L416 96C416 140.2 380.2 176 336 176L320 176zM96 352C96 275.7 131.7 192 208 192C235.3 192 267.7 202.3 290.7 211.3C309.5 218.6 330.6 218.6 349.4 211.3C372.3 202.4 404.8 192 432.1 192C508.4 192 544.1 275.7 544.1 352C544.1 480 464.1 576 384.1 576C367.6 576 346 569.4 332.6 564.7C324.5 561.9 315.7 561.9 307.6 564.7C294.2 569.4 272.6 576 256.1 576C176.1 576 96.1 480 96.1 352z" />
    </svg>
  ),
};
